import React, { Component } from 'react'
import { money, makeid } from '../../utils/helpers'
import { getProductCollections } from '../../utils/Product'
import { makeLineItem, addLineItems } from '../../utils/Cart.js'
import { connect } from 'react-redux'

class ProductTile extends Component {
  constructor(props) {
    super(props)
    // const subtitles = ['Classic', 'Arc En Ciel', 'Essential', 'Spectator', 'Sheen', 'Patent', 'Patents', 'Monogram', 'Debossed']
    const badges = ['Collaboration', 'Coming Soon', 'pre-order']
    const data = props.props
    this.state = {
      data: data,
      currentVariant: data.variants[0],
      subtitles: data.tags.filter((tag) => window.productTileSubtitles.includes(tag)),
      badges: data.tags.filter((tag) => badges.includes(tag)),
      swiper: null,
      media: data.media.filter((m) => m.media_type.toLowerCase() == 'image'),
      wishlistPage: location.href.includes('/pages/wishlist'),
      context: data.context || 'default',
      tileKey: makeid(5),
      discountTag: data.tags.filter((tag) => tag.toLowerCase().includes('% off'))[0] || null,
      parentCollection: data.collections?.edges?.filter((edge) => edge.node.title.includes('_linked'))[0]?.node,
    }

    this.swiperRef = React.createRef()
    console.log('Proudct Tile! ', this.state)
  }

  imageUrl(url, related = false, size = null) {
    const width = size ? size : related ? 380 : 480
    return url
      .replace('.jpg?', `.jpg?width=${width}&`)
      .replace('.png?', `.png?width=${width}&`)
      .replace('.webp?', `.webp?width=${width}&`)
  }

  productUrl() {
    return `${this.state.data.collectionHandle ? '/collections/' + this.state.data.collectionHandle : ''}/products/${this.state.data.handle}`
  }

  handleTileClick(e) {
    // Swiper slides sit at z-index:1 and paint over the overlay <a>, so image clicks never reach it; navigate here (swipe still works: Swiper suppresses the post-drag click).
    if (e.target.closest('button, a')) return
    window.location.href = this.productUrl()
  }

  swatchStyle(sku) {
    return {
      backgroundImage: `url(${location.origin}/cdn/shop/files/${sku.split('-')[sku.split('-').length - 1]}_PDP.jpg?width=16)`,
    }
  }

  backSlides(swiper) {
    const itemsWrapper = swiper.wrapperEl.closest('.related-products')
    const relatedItems = itemsWrapper ? itemsWrapper.querySelectorAll('[data-product-swiper]') : []
    relatedItems.forEach((relatedItem) => {
      if (relatedItem.swiper.wrapperEl != swiper.wrapperEl) {
        relatedItem.swiper.slideTo(0, 0, false)
      }
    })
  }

  addToCart(e) {
    e.stopPropagation()
    e.preventDefault()
    const items = [
      makeLineItem(
        this.state.currentVariant.id.toString().replace('gid://shopify/ProductVariant/', ''),
        1,
        this.state.data.tags,
      ),
    ]
    addLineItems(null, items, true, e.target)
    e.target.disabled = true
  }

  componentDidMount() {
    this.swiperRef.current.closest('[product-tile]').setAttribute('product-tile', true)
    if (this.state.media.length > 1) {
      new Swiper(this.swiperRef.current, {
        speed: 500,
        effect: 'fade',
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          navigationPrev: (swiper) => {
            this.backSlides(swiper)
          },
          navigationNext: (swiper) => {
            this.backSlides(swiper)
          },
          afterInit: (swiper) => {
            this.swiperRef.current
              .querySelector('.swiper-button-prev')
              .addEventListener('click', (e) => e.stopPropagation())
            this.swiperRef.current
              .querySelector('.swiper-button-next')
              .addEventListener('click', (e) => e.stopPropagation())
          },
        },
      })
    }

    if (typeof this.state.data.collectionLoaded == 'undefined' || !this.state.data.collectionLoaded) {
      getProductCollections((product) => {
        if (product) {
          this.setState({
            data: Object.assign(this.state.data, {
              siblings:
                typeof product.collections != 'undefined' &&
                product.collections.edges.filter((edge) => edge.node.title.includes('_linked')).length
                  ? product.collections.edges
                      .filter((edge) => edge.node.title.includes('_linked'))[0]
                      .node.products.edges.filter((edge) => edge.node.onlineStoreUrl)
                      .map((edge) => ({
                        sku: edge.node.variants.edges[0].node.sku,
                        colorName:
                          edge.node.variants.edges[0].node.selectedOptions?.find((o) => o.name === 'Color')?.value ||
                          edge.node.variants.edges[0].node.title,
                      }))
                  : [],
            }),
            parentCollection: product.collections?.edges?.filter((edge) => edge.node.title.includes('_linked'))[0]
              ?.node,
          })
        }
      }, this.state.data.id)
    }
  }

  render() {
    const showSaleTag =
      window.showComparePricePercent &&
      this.state.data.comparePrice &&
      this.state.data.comparePrice > this.state.data.price &&
      this.state.discountTag
    const showColorInfo =
      this.state.data.options_by_name.Color && this.state.data.siblings.length > (window.hideTileSwatches ? 1 : 0)
    return (
      <div className={`product-tile relative product-tile--${this.state.context}`}>
        {this.props.colorMode == 'one' && this.state.parentCollection && (
          <style>
            {`.product-group-${this.state.parentCollection.id.replace('gid://shopify/Collection/', '')} ~ .product-group-${this.state.parentCollection.id.replace('gid://shopify/Collection/', '')} { display: none !important; }`}
          </style>
        )}
        <div className="product-tile--inner group relative no-underline">
          <a
            href={this.productUrl()}
            className="product-tile--container absolute inset-0 z-[1]"
            aria-label={`${this.state.data.title}${this.state.currentVariant.selectedOptions && this.state.currentVariant.selectedOptions[0] && this.state.currentVariant.selectedOptions[0].value !== 'Default Title' ? ` in ${this.state.currentVariant.selectedOptions[0].value}` : ''} ${money(this.state.data.price)}`}
          ></a>
          <div
            className={`product-tile--image relative group ${this.state.wishlistPage ? 'mb-4' : 'mb-3 lg:mb-6'}`}
            onClick={(e) => this.handleTileClick(e)}
          >
            <div className="relative" data-product-swiper={this.state.data.id} ref={this.swiperRef}>
              {this.state.data.tags.includes('in grid promo') ? (
                <div className="relative lg:h-0 lg:pb-[125%] overflow-hidden bg-grid">
                  <div className="p-3 lg:p-0 lg:absolute lg:inset-6 flex flex-col justify-between gap-10">
                    {this.state.data.grid && this.state.data.grid.title && (
                      <div className="text-white text-[1.25rem] lg:text-[2rem] leading-[1.2] lg:leading-[1.125] uppercase font-bold">
                        {this.state.data.grid.title}
                      </div>
                    )}
                    {this.state.data.grid && this.state.data.grid.text && (
                      <div
                        className="text-white text-sm leading-4"
                        dangerouslySetInnerHTML={{ __html: this.state.data.grid.text }}
                      />
                    )}
                  </div>
                </div>
              ) : (
                <div className="swiper-wrapper bg-white focus:outline">
                  {this.state.media.map((image, index) => (
                    <div
                      className="swiper-slide h-full max-w-full"
                      data-index={index}
                      key={`${this.state.data.id}-${index}`}
                    >
                      <div className="relative h-0 pb-[125%] overflow-hidden">
                        {this.state.data.related && (
                          <img
                            className="absolute w-full h-full top-1/2 left-1/2 object-cover transform -translate-x-1/2 -translate-y-1/2"
                            src={this.imageUrl(image.preview_image.src, this.state.data.related)}
                            alt=""
                            loading="lazy"
                            width={image.width}
                            height={image.height}
                          />
                        )}
                        {!this.state.data.related && (
                          <>
                            {index == 0 ? (
                              <picture>
                                <source
                                  media="(min-width:2880px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 1400)}
                                />
                                <source
                                  media="(min-width:2560px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 1200)}
                                />
                                <source
                                  media="(min-width:2048px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 900)}
                                />
                                <source
                                  media="(min-width:1920px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 800)}
                                />
                                <source
                                  media="(min-width:1600px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 700)}
                                />
                                <source
                                  media="(min-width:1440px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 600)}
                                />
                                <source
                                  media="(min-width:1300px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 550)}
                                />
                                <source
                                  media="(min-width:1024px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 500)}
                                />
                                <source
                                  media="(min-width:901px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 600)}
                                />
                                <source
                                  media="(min-width:768px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 550)}
                                />
                                <source
                                  media="(min-width:600px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 450)}
                                />
                                <source
                                  media="(min-width:500px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 360)}
                                />
                                <source
                                  media="(min-width:400px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 300)}
                                />
                                <source
                                  media="(min-width:320px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 240)}
                                />
                                <img
                                  className="absolute w-full h-full top-1/2 left-1/2 object-cover transform -translate-x-1/2 -translate-y-1/2"
                                  src={this.imageUrl(image.preview_image.src, false, 240)}
                                  alt=""
                                  fetchpriority="high"
                                  width={image.width}
                                  height={image.height}
                                />
                              </picture>
                            ) : (
                              <picture>
                                <source
                                  media="(min-width:2880px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 1400)}
                                />
                                <source
                                  media="(min-width:2560px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 1200)}
                                />
                                <source
                                  media="(min-width:2048px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 900)}
                                />
                                <source
                                  media="(min-width:1920px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 800)}
                                />
                                <source
                                  media="(min-width:1600px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 700)}
                                />
                                <source
                                  media="(min-width:1440px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 600)}
                                />
                                <source
                                  media="(min-width:1300px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 550)}
                                />
                                <source
                                  media="(min-width:1024px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 500)}
                                />
                                <source
                                  media="(min-width:901px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 600)}
                                />
                                <source
                                  media="(min-width:768px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 550)}
                                />
                                <source
                                  media="(min-width:600px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 450)}
                                />
                                <source
                                  media="(min-width:500px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 360)}
                                />
                                <source
                                  media="(min-width:400px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 300)}
                                />
                                <source
                                  media="(min-width:320px)"
                                  srcSet={this.imageUrl(image.preview_image.src, false, 240)}
                                />
                                <img
                                  className="absolute w-full h-full top-1/2 left-1/2 object-cover transform -translate-x-1/2 -translate-y-1/2"
                                  src={this.imageUrl(image.preview_image.src, false, 240)}
                                  alt=""
                                  loading="lazy"
                                  width={image.width}
                                  height={image.height}
                                />
                              </picture>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {this.state.media.length > 1 && (
                <button
                  className="swiper-button swiper-button-prev !text-second !h-auto after:!hidden !top-1/2 !-translate-y-1/2 !left-0 lg:!left-4 !hidden lg:group-hover:!flex lg:group-focus-within:!flex focus:outline relative !z-[2]"
                  aria-label="Previous"
                  dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-arrow'] }}
                  tabIndex={0}
                />
              )}
              {this.state.media.length > 1 && (
                <button
                  className="swiper-button swiper-button-next !text-second !h-auto after:!hidden !top-1/2 !-translate-y-1/2 !right-0 lg:!right-4 !hidden lg:group-hover:!flex lg:group-focus-within:!flex focus:outline relative !z-[2]"
                  aria-label="Next"
                  dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-arrow-right'] }}
                  tabIndex={0}
                />
              )}
              {this.state.media.length > 1 && (
                <div className="swiper-pagination !block lg:!hidden !static mt-1 !h-0.5" />
              )}
            </div>

            <div className="product-card-badges absolute top-0 left-0 right-24 flex gap-2 flex-wrap p-2 lg:p-3 z-[1] w-max">
              {this.state.data.tags.includes('Final Sale') && (
                <span className="bg-lss-navy bg-opacity-10 text-sm leading-4 text-black px-2 py-1 capitalize">
                  Final Sale
                </span>
              )}
              {this.state.data.comparePrice &&
                this.state.data.comparePrice > this.state.data.price &&
                !this.state.data.tags.includes('Final Sale') && (
                  <span className="bg-lss-navy bg-opacity-10 text-sm leading-4 text-black px-2 py-1 capitalize">
                    Sale
                  </span>
                )}
              {this.state.badges.includes('Coming Soon') && (
                <span className="bg-lss-navy bg-opacity-10 text-sm leading-4 text-black px-2 py-1 capitalize">
                  Coming Soon
                </span>
              )}
              {this.state.badges.includes('pre-order') && (
                <span className="bg-lss-navy bg-opacity-10 text-sm leading-4 text-black px-2 py-1 capitalize">
                  Pre-Order
                </span>
              )}
              {!this.state.badges.includes('Coming Soon') &&
                !this.state.badges.includes('pre-order') &&
                this.state.badges.map((badge, index) => (
                  <span
                    className="bg-lss-navy bg-opacity-10 text-sm leading-4 text-black px-2 py-1 capitalize"
                    key={`product-badge-${this.state.data.id}-${index}`}
                  >
                    {badge}
                  </span>
                ))}
            </div>

            {!this.state.badges.includes('Coming Soon') && !this.state.data.tags.includes('SOLD OUT') && (
              <>
                {this.state.data.variants.filter((v) => v.available || v.availableForSale).length > 0 ? (
                  <button
                    className="quick-atc button button--secondary button--small !border-black !text-black hover:!text-white hover:!bg-black absolute bottom-4 lg:bottom-5 inset-x-3 lg:inset-x-4 !flex lg:!hidden lg:group-hover:!flex lg:group-focus-within:!flex !z-[2] !px-2 !py-1 lg:!py-2 focus:outline"
                    onClick={(e) => this.addToCart(e)}
                  >
                    ADD TO BAG
                  </button>
                ) : null}
              </>
            )}
            {this.state.wishlistPage && (
              <button
                className="w-4 h-4 !z-[2] inline-flex items-center justify-center absolute top-2.5 right-2.5 text-black"
                dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-close'] }}
                data-wishlist-remove={this.state.currentVariant.id}
              />
            )}
          </div>
          {!this.state.wishlistPage && (
            <>
              {this.state.subtitles.length > 0 && !this.state.data.tags.includes('in grid promo') && (
                <div className="flex text-sm leading-4 mb-2 plp-tile-zoomable">{this.state.subtitles.join(', ')}</div>
              )}

              {this.state.data.tags.includes('in grid promo') ? null : (
                <span
                  className={`product-tile--title flex flex-col gap-2 ${this.state.data.context == 'search' ? '' : 'lg:flex-row lg:gap-6'} justify-between lg:mb-2 no-underline focus:underline plp-tile-zoomable`}
                  href={this.productUrl()}
                >
                  <span className="visually-hidden">Learn more about product</span>
                  <span className="text-base uppercase block" aria-hidden="true">
                    {this.state.data.title}
                  </span>
                  <span className="flex items-center gap-x-4 gap-y-1 lg:gap-x-3 lg:gap-y-3 text-sm leading-4 lg:text-base lg:leading-6 flex-wrap lg:flex-nowrap">
                    {window.showComparePricePercent && (
                      <>
                        {this.state.data.comparePrice && this.state.data.comparePrice > this.state.data.price && (
                          <del>{money(this.state.data.comparePrice)}</del>
                        )}
                      </>
                    )}
                    <span aria-hidden="true">{money(this.state.data.price)}</span>

                    {window.showComparePricePercent && (
                      <>
                        {this.state.data.comparePrice &&
                          this.state.data.comparePrice > this.state.data.price &&
                          this.state.discountTag && (
                            <span className="w-max text-sm text-tile-sale inline-block lg:hidden">
                              {this.state.discountTag}
                            </span>
                          )}
                      </>
                    )}

                    {this.state.data.tags.includes('SOLD OUT') && (
                      <span className="text-xs lg:text-sm" aria-hidden="true">
                        Sold Out
                      </span>
                    )}
                    {this.state.data.siblings.length > 1 && (
                      <span className="plp-tile-swatches-mobile-count inline-block lg:hidden" aria-hidden="true">
                        Colors <sup aria-hidden="true">{this.state.data.siblings.length}</sup>
                      </span>
                    )}
                  </span>
                  <span className="visually-hidden">
                    {this.state.data.id.toString().replace('gid://shopify/Product/', '')} - Details -{' '}
                    {this.state.tileKey}
                  </span>
                </span>
              )}
              {/* {
                this.state.data.showATC && <button className='w-full button !bg-fore !text-back hover:!border-fore hover:!bg-transparent hover:!text-fore mt-3 !px-4 !text-sm !leading-4 box-border' data-product-add onClick={(e) => this.addToCart(e)}>
                  Add to bag
                </button>
              } */}
            </>
          )}
        </div>
        {(showColorInfo || showSaleTag) && (
          <div
            className={`hidden lg:flex gap-2 plp-tile-zoomable ${this.state.data.context == 'search' ? 'flex-wrap flex-col justify-start' : 'items-center'}`}
          >
            {showColorInfo && !window.hideTileSwatches && (
              <div className="plp-tile-swatches flex gap-2">
                {this.state.data.siblings.map((sibling, index) => {
                  if (this.state.data.siblings.length <= 5 || (this.state.data.siblings.length > 5 && index < 4))
                    return (
                      <span
                        className={`rounded-full bg-no-repeat	bg-cover bg-center overflow-hidden w-4 h-4 ${this.props.colorMode == 'one' && index > 0 ? 'hidden' : 'inline-block'}`}
                        style={this.swatchStyle(sibling.sku)}
                        aria-label={sibling.colorName}
                        key={`${this.state.data.id}-swatch-${index}`}
                      >
                        <span className="visually-hidden">{sibling.colorName}</span>
                      </span>
                    )
                  else return ''
                })}
              </div>
            )}
            {showColorInfo && this.state.data.siblings.length > 1 && (
              <a
                className="plp-tile-colors-count font-tinos text-sm leading-4 no-underline hover:underline focus:underline"
                href={this.productUrl()}
                aria-label={`${this.state.data.siblings.length} colors available for ${this.state.data.title}`}
              >
                <span aria-hidden="true">+ {this.state.data.siblings.length} Colors</span>
              </a>
            )}
            {showSaleTag && (
              <span
                className={`w-max text-sm text-tile-sale ${this.state.data.context == 'search' ? '' : 'ml-auto mr-0'}`}
              >
                {this.state.discountTag}
              </span>
            )}
          </div>
        )}
        {!this.state.wishlistPage && (
          <button
            className={`plp-wishlist-btn focus:!outline !z-[1] !absolute top-3 right-3 swym-button swym-add-to-wishlist-view-product product_${this.state.data.id.toString().replace('gid://shopify/Product/', '')} !visible !opacity-100`}
            data-with-epi={true}
            // data-product-title={ this.state.data.title }
            data-swaction="addToWishlist"
            data-product-id={this.state.data.id.toString().replace('gid://shopify/Product/', '')}
            data-variant-id={this.state.currentVariant.id.toString().replace('gid://shopify/ProductVariant/', '')}
            data-product-url={`https://${location.host}${this.state.data.url}`}
          >
            <span className="text-black" dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-heart'] }} />
            <span
              className="text-black"
              dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-heart-filled'] }}
            />
            <span className="visually-hidden">Add to wishlist</span>
          </button>
        )}
        {this.state.wishlistPage && (
          <>
            <a className="block mb-4 no-underline" href={this.productUrl()}>
              <h3 className="text-sm leading-4 uppercase font-bold mb-1.5">{this.state.data.title}</h3>
              <div className="text-sm leading-5 capitalize">
                {this.state.currentVariant.selectedOptions[0].value == 'Default Title' ? (
                  ''
                ) : (
                  <>
                    {this.state.currentVariant.selectedOptions[0].value}
                    <br />
                  </>
                )}
                {money(this.state.data.price)}
              </div>
            </a>
            {this.state.currentVariant.availableForSale ? (
              <button
                className="w-full button !bg-green-2 !text-black !border-green-2 hover:!border-fore hover:!bg-transparent hover:!text-fore !px-4 !text-xl !leading-6"
                data-product-add
                onClick={(e) => this.addToCart(e)}
                tabIndex={0}
              >
                Add to cart
              </button>
            ) : (
              <span className="w-full button !bg-fore !text-fore !bg-transparent hover:!border-fore hover:!bg-transparent hover:!text-fore !px-4 !text-xl !leading-6">
                Sold out
              </span>
            )}
          </>
        )}
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    colorMode: state.productTile.colorMode,
  }
}

// const mapDispatchToProps = dispatch => {
//   return {
//     // increase: () => {
//     //   dispatch({
//     //     type: 'INCREASE'
//     //   })
//     // },
//   }
// }

// export default connect(mapStateToProps, mapDispatchToProps)(ProductTile)
export default connect(mapStateToProps)(ProductTile)
// export default ProductTile
